"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearDisqualificationSchema = exports.setDisqualificationSchema = exports.DISQUALIFICATION_REASON_MAX = exports.DISQUALIFICATION_REASON_MIN = exports.DISQUALIFIABLE_PARTNERS = exports.disqualifiablePartnerSchema = void 0;
const zod_1 = require("zod");
const financing_1 = require("../financing");
// The per-lender disqualified-counterparty list the eligibility engine reads as
// `buyer_disqualified` / `supplier_disqualified`. Row presence is the whole state: a removal is a
// delete plus a history event, never a status change.
// METYCLE is excluded for the same open trading-policy reason the location-acceptance surface
// excludes it. The list derives from the partner enum rather than a second hardcoded tuple, so a
// future partner reaches the picker without a code change.
exports.disqualifiablePartnerSchema = financing_1.financingPartnerSchema.exclude(['METYCLE']);
exports.DISQUALIFIABLE_PARTNERS = exports.disqualifiablePartnerSchema.options;
exports.DISQUALIFICATION_REASON_MIN = 20;
exports.DISQUALIFICATION_REASON_MAX = 2000;
const reason = zod_1.z.string().trim().min(exports.DISQUALIFICATION_REASON_MIN).max(exports.DISQUALIFICATION_REASON_MAX);
// A reason is mandatory on both directions (ruling 28 Jul): the history event carries it either
// way, and a removal without one leaves an unexplained event in the audit trail.
exports.setDisqualificationSchema = zod_1.z
    .object({ partner: exports.disqualifiablePartnerSchema, reason })
    .strict();
exports.clearDisqualificationSchema = zod_1.z
    .object({ partner: exports.disqualifiablePartnerSchema, reason })
    .strict();
//# sourceMappingURL=disqualified-partners.js.map